import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';
import { TableHeader } from './TableHeader';
import { ContactRow } from './ContactRow';
import { Drawer, Skeleton } from '@mui/material';
import { ProspectDto } from '@zaplify/prospects';
import { ProspectsPanel } from '../../../prospecting/search-view/table-view/prospect-details';

type Props = {
    prospects: ProspectDto[];
    loading: boolean;
    onSelectRow: (userContacts: ProspectDto | ProspectDto[]) => void;
    selectedRows: Record<string, ProspectDto>;
};

export const UserContactsTable = ({ prospects, loading, onSelectRow, selectedRows }: Props) => {
    const [userContactClicked, setUserContactClicked] = useState<ProspectDto | null>(null);

    const handleCheckboxClick = (event: any, prospect: ProspectDto) => {
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
        onSelectRow(prospect);
    };

    const handleSelectAllContacts = (event) => {
        if (event.target.checked) {
            onSelectRow(prospects);
        } else onSelectRow([]);
    };

    const isSelected = (id: string) => {
        return !!selectedRows[id];
    };

    const handleRowClick = (event: any, prospect: ProspectDto) => {
        if (event.stopPropagation) event.stopPropagation();
        setUserContactClicked(prospect);
    };

    const selectedOnPage = prospects?.reduce((acc, item) => {
        return selectedRows[item.id] ? ++acc : acc;
    }, 0);

    const SkeletonRows = () => {
        const rows = [];
        const DEFAULT_ROWS_PER_PAGE = 10;
        for (let i = 0; i < DEFAULT_ROWS_PER_PAGE; i++) {
            rows.push(
                <TableRow sx={{ py: 0 }} key={i}>
                    <TableCell sx={{ py: 0 }} colSpan={8}>
                        <Skeleton width={'100%'} height={69} />
                    </TableCell>
                </TableRow>
            );
        }
        return <>{rows}</>;
    };

    return (
        <>
            {userContactClicked && (
                <Drawer
                    open={!!userContactClicked}
                    onClose={() => setUserContactClicked(null)}
                    anchor="right"
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            width: '307px',
                            height: '100%',
                            backgroundColor: 'white',
                            boxShadow: 24,
                            overflowY: 'auto',
                        }}
                    >
                        <ProspectsPanel
                            prospect={userContactClicked.data}
                            isPreview={false}
                            prospectIsLoading={false}
                            onClose={() => setUserContactClicked(null)}
                        />
                    </Box>
                </Drawer>
            )}

            <Box sx={{ width: '100%' }}>
                <Box sx={{ width: '100%' }}>
                    <TableContainer
                        sx={{
                            borderRadius:
                                'var(--radius-xl, 14px) var(--radius-xl, 14px) var(--radius-none, 0px) var(--radius-none, 0px)',
                        }}
                    >
                        <Table
                            aria-labelledby="userContactsTable"
                            size={'small'}
                            sx={{
                                minWidth: 750,
                                borderRadius: 'var(--radius-xl, 14px)',
                            }}
                        >
                            <TableHeader
                                numSelected={selectedOnPage}
                                onSelectAllClick={handleSelectAllContacts}
                                rowCount={prospects?.length || 0}
                            />
                            <TableBody
                                sx={{
                                    borderRadius: 'var(--radius-xl, 14px)',
                                    width: '100%',
                                    display: 'table-row-group',
                                }}
                            >
                                {loading || prospects === null ? (
                                    <SkeletonRows />
                                ) : (
                                    <>
                                        {prospects.map((prospect, index) => (
                                            <ContactRow
                                                key={prospect.id}
                                                prospect={prospect}
                                                selected={isSelected(prospect.id)}
                                                handleRowClick={handleRowClick}
                                                handleCheckboxClick={handleCheckboxClick}
                                                labelId={`enhanced-table-checkbox-${index}`}
                                            />
                                        ))}
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </>
    );
};
